import { getTeamOrPlayerImageUrl } from '~/domains/common/utils/getTeamOrPlayerImageUrl';
import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';

import type { PlayerInfo } from '../../types/player';

import { parseName } from './utils';

const parseBasePlayerInfo = (
  pick: PlayerPoolMember,
  leagueAlias?: string
): Partial<PlayerInfo> => ({
  playerId: pick.playerId,
  playerName: parseName(pick.name),
  playerPoolMemberId: pick.playerPoolMemberId || pick.id,
  playerImage: leagueAlias ? getTeamOrPlayerImageUrl(leagueAlias, pick.playerId) : undefined,
  weatherIcon: pick.weatherIcon,
});

export default parseBasePlayerInfo;
